import { SystemNotificationPreference } from '@hakimo-ui/hakimo/types';
import {
  isWebNotificationSupported,
  pageTitleAtom,
  systemNotifyAtom,
} from '@hakimo-ui/hakimo/util';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

export function RootHeader() {
  const { pageTitleNode, pageActions } = useAtomValue(pageTitleAtom);
  const setSystemNotifyPreference = useSetAtom(systemNotifyAtom);
  useEffect(() => {
    // handle scenario where user has manually denied notification permission
    if (isWebNotificationSupported()) {
      global.Notification.permission !== 'granted' &&
        setSystemNotifyPreference(SystemNotificationPreference.OFF);
    }
  }, [setSystemNotifyPreference]);

  return (
    <div className="bg-hakimo-light-bg dark:bg-hakimo-dark-bg px-4">
      <div className="dark:bg-ondark-bg-1 dark:text-dark-text bg-onlight-bg-1 sticky top-0 z-10 flex h-14 items-center justify-between rounded-b-lg px-4">
        <div className="text-lg font-medium">
          <span>{pageTitleNode}</span>
        </div>
        {pageActions && (
          <div className="flex items-center gap-2">{pageActions}</div>
        )}
      </div>
    </div>
  );
}

export default RootHeader;
